import Vue from "vue";

export default {
  getRoles({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit("ROLE_MUTATIONS", { key: "rolesLoading", value: true });

      const params = { page: state.page, perPage: state.perPage };

      Vue.$http
        .get("/organization/system-settings/roles", { params })
        .then(response => {
          commit("ROLE_MUTATIONS", {
            key: "roles",
            value: response.data.results,
          });
          commit("ROLE_MUTATIONS", {
            key: "rolesTotal",
            value: response.data.total,
          });
          commit("ROLE_MUTATIONS", { key: "rolesLoading", value: false });

          resolve(response);
        })
        .catch(error => {
          commit("ROLE_MUTATIONS", { key: "rolesLoading", value: false });
          Vue.$notification.error(error.message);

          reject(error);
        });
    });
  },

  getSingleRole(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/organization/system-settings/roles/${id}`)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },

  handleSizeChange({ commit, dispatch }, perPage) {
    commit("ROLE_MUTATIONS", { key: "perPage", value: perPage });
    commit("ROLE_MUTATIONS", { key: "page", value: 1 });
    dispatch("getRoles");
  },

  handleCurrentChange({ commit, dispatch }, page) {
    commit("ROLE_MUTATIONS", { key: "page", value: page });
    dispatch("getRoles");
  },

  getRoleMembers(_, { id, page, perPage, searchQuery }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/organization/system-settings/roles/${id}/members`, {
          params: {
            page,
            perPage,
            ...(searchQuery && { search_query: searchQuery }),
          },
        })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },

  deleteMembersFromRole(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/organization/system-settings/roles/${params.id}/members`, {
          params: { user_ids: params.userIds },
        })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },

  getRolePermissions(_, { id, page, perPage, searchQuery }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/organization/system-settings/roles/${id}/permissions`, {
          params: {
            page,
            perPage,
            ...(searchQuery && { search_query: searchQuery }),
          },
        })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },

  deletePermissionsFromRole(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(
          `/organization/system-settings/roles/${params.id}/permissions`,
          {
            params: { permission_ids: params.permissionIds },
          }
        )
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },

  addEmployeesToRole(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(
          `/organization/system-settings/roles/${params.role_id}/employees`,
          { employee_id: params.employee_id }
        )
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
  getModulesToAccess() {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/organization/system-settings/group-permissions-by-modules")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createRole(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/organization/system-settings/roles", payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateRole(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put("/organization/system-settings/roles", payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteRole(_, id) {
    const params = { id };
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete("/organization/system-settings/roles", { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  resetUserPassword(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put("/organization/system-settings/reset-user-password", payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
